import { useParams } from "react-router-dom";
import { useStore } from "@/stores/useStore";
import { BreadcrumbPage } from "@/components/Page/BreadcrumbPage";
import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";
import { useRoles } from "@/hooks/useRoles";
import { Loading } from "@/components/Page/Loading";
import { Forbidden } from "@/components/Page/Forbidden";
import { Spinner } from "@/components/Common/Spinner";
import { CardsTable } from "@/components/Cards/CardsTable";
import { useTerminologyReplacer } from "@/hooks/useTerminologyReplacer";
import { TerminologyOptions } from "@/types/v2";

const CardsListPage = () => {
  const { shopId } = useParams();
  const { terminolize } = useTerminologyReplacer();
  const { isSuperAdmin, isAdmin, isOffice, isTechnician, isInitialized } =
    useRoles();
  useIsAuthenticated();
  const shop = useStore((s) => s.shop);
  const employees = useStore((s) => s.employees);

  if (!shopId) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isInitialized) return <Loading />;
  if (isInitialized && !(isSuperAdmin || isAdmin || isOffice || isTechnician))
    return <Forbidden />;

  if (!shop) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  const breadcrumbs = [
    { label: "Dashboard", href: `/${shopId}` },
    {
      label: terminolize(
        "Repair Orders",
        TerminologyOptions.repairOrder,
        "plural"
      ),
    },
  ];

  return (
    <BreadcrumbPage breadcrumbs={breadcrumbs}>
      <div className="flex flex-col space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">
            {terminolize(
              "Repair Orders",
              TerminologyOptions.repairOrder,
              "plural"
            )}
          </h1>
        </div>

        <div className="flex-1">
          <CardsTable shopId={shopId} employees={employees || []} />
        </div>
      </div>
    </BreadcrumbPage>
  );
};

export default CardsListPage;
